import { useEffect, useRef, useState } from "react";

/** Hide the bottom nav while scrolling down past `showThreshold`, show again on
 * upward scroll. Movement < `delta` is ignored to avoid jitter. */
export default function useMobileNavScroll({ showThreshold = 80, delta = 8 } = {}) {
  const [hidden, setHidden] = useState(false);
  const lastY = useRef(0);

  useEffect(() => {
    lastY.current = window.scrollY || 0;
    const onScroll = () => {
      const y = window.scrollY || 0;
      const diff = y - lastY.current;
      if (Math.abs(diff) < delta) return;
      if (y > showThreshold && diff > 0) setHidden(true);
      else if (diff < 0) setHidden(false);
      lastY.current = y;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [showThreshold, delta]);

  return { hidden, setHidden };
}
